import React from 'react';
import PropTypes from 'prop-types';
import {
  FDContentContainer,
  FDStack,
  FDStat,
} from '@facet-wealth/design';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

const EstimatedPaycheckStat = ({ label, value }) => {
  return <FDStat label={label} value={value} />;
};


EstimatedPaycheckStat.defaultProps = {};

EstimatedPaycheckStat.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};


const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride(['primaryEstimatedPaycheck', 'spouseEstimatedPaycheck'], {
    _component: () => EstimatedPaycheckStat,
  }, {
    ordinal: 200,
  });

const EstimatedPaycheckLayout = () => {
  return (
    <FDContentContainer maxWidth="sm">
      <FDStack direction="row" alignItems="stretch" spacing={2}>
        <FDStack spacing={2} flexGrow={1}>
          <MetaControlField attr="primaryEstimatedPaycheck" />
        </FDStack>
        <FDStack spacing={2} flexGrow={1}>
          <MetaControlField attr="spouseEstimatedPaycheck" />
        </FDStack>
      </FDStack>
    </FDContentContainer>
  );
};

const EstimatedPaycheckSection = ({
  resource,
}) => {
  if (!resource) {
    return null;
  }

  return (
    <MetaFormInline
      padding="none"
      noIndividualSubmitButtons
      resource={resource}
      layout={EstimatedPaycheckLayout}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

EstimatedPaycheckSection.defaultProps = {};

EstimatedPaycheckSection.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default EstimatedPaycheckSection;
